import { SessionLive, SessionProperties, SessionState } from '@yospace/admanagement-sdk';

let currentGuid: string | null = null;
let currentLiveSession: SessionLive | null = null;

type customHeaders = Map<any, any>;
/**
 * Creates a Yospace session manager for live playback.
 */
async function createLiveSessionManager(src: string, customHeaders?: customHeaders) {
  const properties = new SessionProperties();
  properties.setUserAgent(navigator.userAgent);
  if (customHeaders) properties.setCustomHttpHeaders(customHeaders);

  // SessionLive.create()'s third argument is optional but the types are wrong.
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore next-line
  const session = await SessionLive.create(src, properties);

  if (session.getSessionState() === SessionState.INITIALISED) {
    return session;
  }
  throw new Error(`Failed to create Yospace session - ResultCode: ${session.getResultCode()}`);
}

export function shutdownLiveSessionManager() {
  if (currentLiveSession && currentLiveSession !== null) {
    currentLiveSession.shutdown();
    currentLiveSession = null;
    currentGuid = null;
  }
}

export async function getLiveSessionManager(
  { src, metadata, sources, map }: any,
  customHeaders?: customHeaders
) {
  const sessionSrc = src ?? sources[0].src;
  if (currentGuid === metadata?.guid) {
    return currentLiveSession;
  }

  try {
    currentLiveSession = await createLiveSessionManager(sessionSrc, customHeaders);
    currentGuid = metadata?.guid;
  } catch (e) {
    currentLiveSession = null;
    currentGuid = null;
  }

  return currentLiveSession;
}
